import { connect } from 'react-redux'
import get from 'lodash/get'

import {
  changeIntelligenceType as onChangeIntelligenceType
} from '../../actions/timeRangeIntelligenceType'
import { intelligenceTypes } from '../../components/sections/intellegence/static.timeRangeIntelligenceTypes'

const mapStateToProps = (state) => ({
  intelligenceType: get(state, ['timeRangeIntelligenceType', 'intelligenceType'], intelligenceTypes.general.value)
})

const mapDispatchToProps = {
  onChangeIntelligenceType
}

const withTimeRangeIntelligenceType = Component => connect(mapStateToProps, mapDispatchToProps)(Component)

export { withTimeRangeIntelligenceType }